import { render } from "./ByType.vue?vue&type=template&id=e92003be"
import script from "./ByType.vue?vue&type=script&lang=js"
export * from "./ByType.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/help.supaday.app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__